<template>
  <div>
    <load v-if="loading" mode="table" message="Atualizando informações" />

    <form v-show="!loading" @submit.prevent="submit">
      <div class="row">
        <div class="col-md-4">
          <label>STATUS DA API SEPRO</label>

          <select v-model="api_sepro_ativo" class="form-control">
            <option :value="1">Ativo</option>
            <option :value="0">Inativo</option>
          </select>
        </div>
      </div>

      <div class="row px-0 d-flex justify-content-end mt-3">
        <div class="col-auto px-2 text-right">
          <button
            class="btn btn-success btn-submit"
            data-style="zoom-in"
            type="submit"
          >
            <i class="mdi mdi-content-save" />
            {{ $t("Salvar") }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      api_sepro_ativo: 0,
      loading: false,
    };
  },

  mounted() {
    if (
      this.$store.state.settings.familia_api_sepro_ativo !== undefined &&
      this.$store.state.settings.familia_api_sepro_ativo !== null
    ) {
      this.api_sepro_ativo = Number(
        this.$store.state.settings.familia_api_sepro_ativo
      );
    }
  },

  methods: {
    submit() {
      this.loading = true;

      let dados = [
        {
          key: "familia_api_sepro_ativo",
          value: this.api_sepro_ativo,
        },
      ];

      axios
        .post("api/dashboard/admin/familia/settings", dados)
        .then(() => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>